import { ROUTES } from '#/config/routes';
import CustomerPortalPage from '#/modules/customerPortal/pages/CustomerPortalPage';
import LoginPage from '#/modules/infra/pages/LoginPage';
import ErrorPage from '#/modules/infra/router/ErrorPage';
import RootRedirect from '#/modules/infra/router/RootRedirect';

export const publicRoutes = [
  {
    path: '/',
    element: <RootRedirect />,
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES.customerPortal,
    handle: { title: '產品履歷' },
    element: <CustomerPortalPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES.login,
    handle: { title: '登入' },
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
];
